import request from '../utils/http'

const bankapis = {
    //查询银行列表
    getBankList : query => {
        return request({
            url: '/yjBank/getYjBankList',
            method: 'get',
            params:query
        });
    },
        getBankAccountList : query => {
        return request({
            url: '/yjBank/getBankAccountList',
            method: 'get',
            params:query
        });
    },
            getFirstUserListByIds : query => {
        return request({
            url: '/user/getFirstUserListByIds',
            method: 'get',
            params:query
        });
    },
         //新增银行
     addBankAccount : query => {
        return request({
            url: '/yjBank/addYjBankAccount',
            method: 'post',
            data: query
        });
    },
     //修改银行
     updateBankAccount : query => {
        return request({
            url: '/yjBank/updateYjBankAccount',
            method: 'post',
            data: query
        });
    },
     //查看银行详情
     getYjBankById : query => {
        return request({
            url: '/yjBank/getYjBankById',
            method: 'get',
            params: query
        });
    },
     //新增银行
     addBank : query => {
        return request({
            url: '/yjBank/addYjBank',
            method: 'post',
            data: query
        });
    },
     //修改银行
     updateBank : query => {
        return request({
            url: '/yjBank/updateYjBank',
            method: 'post',
            data: query
        });
    },
      //删除银行
      deleteBank : query => {
        return request({
            url: '/yjBank/deleteYjBank',
            method: 'post',
            params: query
        });
    },
         //通过权限查询用户
         getYjUserListByMenuId : query => {
            return request({
                url: '/user/getUserListByMenuId',
                method: 'get',
                params: query
            });
        },
        getContractByCondition : query => {
            return request({
                url: '/yjFlow/getContractByCondition',
                method: 'get',
                params: query
            });
        },
        excelExportContract:query=>{
            return request({
                url:'/yjFlow/excelExportContract',
                method:'post',
                params:query
            })
          },        
        getContractById : query => {
        return request({
            url: '/yjFlow/getContractById',
            method: 'get',
            params: query
        });
        
        },
        deleteYjFlow:query=>{
        return request({
            url: '/yjFlow/deleteYjFlow',
            method:'post',
            data:query
        })
    },
        getYjFlowList: query => {
            return request({
                url: '/yjFlow/getYjFlowList',
                method: 'get',
                params:query
            });
        },
     getYjFlowById : query => {
        return request({
            url: '/yjFlow/getYjFlowById',
            method: 'get',
            params: query
        });
    },
    uploadFile : query => {
        return request({
            url: '/files/uploadFile',
            method: 'post',
            data: query
        });
    },
         //修改流程
         updateYjFlow : query => {
            return request({
                url: '/yjFlow/updateYjFlow',
                method: 'post',
                data: query
            });
        },
        getYjFlowLogByFlowId:query=>{
            return request({
                url:'/flow/getYjFlowLogByFlowId',
                method:'get',
                params:query
            })
        },
            //查询二维码信息
            getYjAuditParam : query => {
        return request({
            url: '/fdd/getYjAuditParam',
            method: 'get',
            params: query
        });
    },
       addYJLoanApply:query=>{
        return request({
            url :'/yjFlow/addYJLoanApply',
            method:'post',
            data:query
        })
    },
    addYJLoanApply2:query=>{
        return request({
            url :'/yjFlow/addYJLoanApply2',
            method:'post',
            data:query
        })
    },
              toUpdateContractState : query => {
        return request({
            url: '/yjFlow/toUpdateContractState',
            method: 'post',
            params: query
        });
    },
   toUpdateContract : query => {
        return request({
            url: '/yjFlow/toUpdateContract',
            method: 'post',
            data:query
        });
    },
   getPCSumData:query=>{
        return request({
            url: '/yjFlow/getPCSumData',
            method:'get',
            params:query
        })
    },
     getDataFourByCondition:query=>{
        return request({
            url: '/yjFlow/getDataFourByCondition',
            method:'get',
            params:query
        })
    },
   getDataChart1:query=>{
        return request({
            url: '/yjFlow/getDataChart1',
            method:'get',
            params:query
        })
    },
    getDataChart2:query=>{
        return request({
            url: '/yjFlow/getDataChart2',
            method:'get',
            params:query
        })
    },
    
}


export default bankapis
